import React, { useMemo } from "react";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import { RevisionRequestsTab } from "./RevisionRequestsTab";
import { useRevisionRequestsPendingCount } from "./RevisionRequestsTab";
import { RevisionUploadsTab } from "./RevisionUploadsTab";
import { useInitialEvaluationContext } from "../../../../hooks/InitialEvaluationContext";
import type { EvaluationRevisionSupplier } from "../types/revision-review.type";

interface LeadRevisionsViewProps {
	evaluationId: number;
	rfxId: number;
}

export const LeadRevisionsView: React.FC<LeadRevisionsViewProps> = ({
	rfxId,
	evaluationId,
}) => {
	const pendingCount = useRevisionRequestsPendingCount(rfxId, evaluationId);
	const { suppliers: evaluationSuppliers } = useInitialEvaluationContext();

	/**
	 * The Upload Revision dropdown previously listed only suppliers that already had
	 * a revision REQUEST, so an evaluation with no requests yet showed an empty
	 * dropdown and the modal could not be used at all. Uploading does not require a
	 * request: RfxRevisionController@store accepts any RfxInvite belonging to the
	 * RFx. Source the full evaluated-supplier list instead.
	 */
	const suppliers: EvaluationRevisionSupplier[] = useMemo(
		() =>
			evaluationSuppliers.map((supplier) => ({
				id: supplier.inviteId,
				name: supplier.supplierName,
			})),
		[evaluationSuppliers]
	);

	return (
		<Tabs data-testid="lead-revisions-tabs" isLazy>
			<TabList>
				<Tab data-testid="tab-revision-requests">
					Revision Requests{pendingCount > 0 && ` (${pendingCount})`}
				</Tab>
				<Tab data-testid="tab-revision-uploads">
					Revision Uploads
				</Tab>
			</TabList>
			<TabPanels>
				<TabPanel data-testid="tab-panel-revision-requests" className="px-0">
					<RevisionRequestsTab
						rfxId={rfxId}
						evaluationId={evaluationId}
					/>
				</TabPanel>
				<TabPanel data-testid="tab-panel-revision-uploads" className="px-0">
					<RevisionUploadsTab
						rfxId={rfxId}
						evaluationId={evaluationId}
						suppliers={suppliers}
					/>
				</TabPanel>
			</TabPanels>
		</Tabs>
	);
};
